import Typography from '@mui/material/Typography/Typography';
import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  highlighted: {
    color: theme.palette.primary.main,
  },
}));

type HighlightableTypographyProps = {
  value: string;
  match: string;
  children: React.ReactNode;
};

const HighlightableTypography = ({ value, match, children }: HighlightableTypographyProps) => {
  const { classes } = useStyles();
  return (
    <Typography className={value === match ? classes.highlighted : undefined} variant='paragraphRegular'>
      {children}
    </Typography>
  );
};

export default HighlightableTypography;
